import React, { Fragment } from 'react';
import { attributeTypes } from '../../../../utils/search';
import ComboBoxAutocomplete from '../../ComboBoxAutocomplete';
import KeyboardDatePicker from '../../KeyboardDatePicker';
import FilterContainerCriteria from './FilterContainerCriteria';
import FilterContainerInput from './FilterContainerInput';

const FilterContainerMenuItem = (props) => {
  const {
      attribute,
      filterAttributes,
      enums,
      criteria,
      input,
      inputRange,
      onChangeCriteria,
      onChangeComboBox,
      onChangeDate,
      onChangeInput,
      onChangeInputRange,
      t,
    } = props || {},
    { Placeholders } = t || {};

  return (
    <Fragment>
      <FilterContainerCriteria
        filterAttributes={filterAttributes}
        onChange={onChangeCriteria}
        enums={enums}
        criteria={criteria}
        t={t}
      />
      {(attribute.type === attributeTypes.TEXT ||
        attribute.type === attributeTypes.NUMBER) && (
        <FilterContainerInput
          input={input}
          onChangeInput={onChangeInput}
          criteria={criteria}
          enums={enums}
          inputRange={inputRange}
          onChangeInputRange={onChangeInputRange}
          t={t}
        />
      )}
      {attribute?.type === attributeTypes.DATE && (
        <KeyboardDatePicker
          label={Placeholders.filter}
          onChange={onChangeDate}
          placement="bottom"
          inputDate={input}
          classNameTextField="smaller-input width-100 background-white"
        />
      )}
      {attribute?.type === attributeTypes.OBJECT && (
        <ComboBoxAutocomplete
          data={attribute.values}
          textExtractor={(a) => a}
          changeValue={(newValue) => onChangeComboBox(newValue)}
          label={Placeholders.filter}
          updateValue={input}
          classNameTextField="smaller-input-combo filter-content-block-body combo-box"
          InputLabelProps={{ shrink: true, height: 30 }}
          filterSelectedOptions
        />
      )}
    </Fragment>
  );
};

export default FilterContainerMenuItem;
